/**
 * Vanilla boss bar (purple, as the Ender Dragon's), in GUI pixels.
 *
 *   const bar = new BossBar(stage.content);
 *   bar.update(fight.bossBar(), stage.width);   // every frame; null hides it
 *
 * Vanilla layout: 182x5 bar at (W/2 - 91, 12), the name centred 9px above it.
 */

import { Label, sprite } from './kit';

export class BossBar {
  private readonly root = document.createElement('div');
  private readonly fill: HTMLDivElement;
  private label: Label | null = null;
  private name = '';
  private frac = -1;
  private width = -1;
  private rowTop = -1;

  /** `top`: GUI-pixel y of the bar (vanilla 12; a second bar stacks 19 px lower). */
  constructor(parent: HTMLElement, private top = 12) {
    this.root.style.cssText = 'position:absolute;left:0;top:0;width:0;height:0;display:none;pointer-events:none;';
    this.fill = sprite('gui/sprites/boss_bar/purple_progress.png', 0, 0, 182, 5);
    this.fill.style.backgroundSize = '182px 5px';
    this.fill.style.overflow = 'hidden';
    parent.appendChild(this.root);
  }

  /** `state` null hides the bar. `stageWidth` is the GUI-pixel width of the stage. */
  update(state: { name: string; fraction: number } | null, stageWidth: number): void {
    if (!state) { this.root.style.display = 'none'; return; }
    this.root.style.display = '';
    if (stageWidth !== this.width || state.name !== this.name || !this.label || this.rowTop !== this.top) {
      this.width = stageWidth;
      this.rowTop = this.top;
      this.name = state.name;
      this.root.replaceChildren();
      const x = Math.floor(stageWidth / 2) - 91;
      const bg = sprite('gui/sprites/boss_bar/purple_background.png', x, this.top, 182, 5);
      this.fill.style.left = x + 'px';
      this.fill.style.top = this.top + 'px';
      this.label = new Label(state.name, Math.floor(stageWidth / 2), this.top - 9, { color: '#ffffff', shadow: true, align: 'center' });
      this.root.append(bg, this.fill, this.label.el);
      this.frac = -1;
    }
    if (state.fraction !== this.frac) {
      this.frac = state.fraction;
      // vanilla draws the progress sprite cropped to floor(fraction * 183) px
      this.fill.style.width = Math.min(182, Math.floor(state.fraction * 183)) + 'px';
      this.fill.style.backgroundSize = '182px 5px';
    }
  }

  /** Move the bar (e.g. under another boss bar); takes effect on the next update. */
  setTop(y: number): void { this.top = y; }

  dispose(): void { this.root.remove(); }
}
